import React from "react";

function Navbar({ search, setSearch }) {
  return (
    <div style={{ backgroundColor: "#171a21", padding: "0.8rem 2rem", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
        <img
          src="https://store.cloudflare.steamstatic.com/public/shared/images/header/logo_steam.svg"
          alt="Steam logo"
          style={{ height: "40px" }}
        />
        <nav style={{ display: "flex", gap: "1rem", fontWeight: "bold", fontSize: "0.95rem" }}>
          <span style={{ cursor: "pointer" }}>OBCHOD</span>
          <span style={{ cursor: "pointer" }}>KOMUNITA</span>
          <span style={{ cursor: "pointer" }}>INFORMACE</span>
          <span style={{ cursor: "pointer" }}>PODPORA</span>
        </nav>
      </div>
      <input
        type="text"
        placeholder="Hledat hry..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        style={{
          backgroundColor: "#316282",
          border: "none",
          padding: "0.4rem 0.8rem",
          borderRadius: "4px",
          color: "white",
          width: "200px",
        }}
      />
    </div>
  );
}

export default Navbar;
